/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Guest } from '../../models/guest';

export interface GuestsControllerFindOne$Params {
  id: string;
}

export function guestsControllerFindOne(http: HttpClient, rootUrl: string, params: GuestsControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<Guest>> {
  const rb = new RequestBuilder(rootUrl, guestsControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Guest>;
    })
  );
}

guestsControllerFindOne.PATH = '/admin/guests/{id}';
